import React from "react"
import Image from "next/image"
import { usePromoCodeActions } from "components/Basket/components/PromoCodes/hooks/usePromoCode"
import { Button } from "packages/ui-shared/components/Button/Button"
import { CheckIcon } from "components/SVG/CheckIcon"
import { color } from "lib/theme/theme.css"
import { promoCodeValue } from "components/Basket/components/PromoCodes/constants"
import {
  promoBannerContent,
  promoBannerCta,
  promoBannerCtaText,
  promoBannerHeadline,
  promoBannerImg,
  promoBannerMediumText,
  promoBannerSvg,
  promoBannerText,
  promoBannerWrapper,
} from "./AddPromoCodeBanner.css"

export const AddPromoCodeBanner = () => {
  const { onUsePromoCode, isPromoCodeActivated, isPromoCodeRejected } =
    usePromoCodeActions()

  const imageSrc = "/images/promo-code/promo_code_box_img.jpg"

  return (
    <div className={promoBannerWrapper}>
      <div>
        <Image
          className={`${promoBannerImg}`}
          src={imageSrc}
          alt=""
          width={589}
          height={550}
          data-testid="promoBannerImage"
          title="image title"
          style={{
            objectFit: "contain",
            objectPosition: "center",
          }}
        />
        <div className={promoBannerContent}>
          <h2 className={promoBannerHeadline}>Save 20% on your first order</h2>
          <p className={promoBannerText}>
            Hurry: take an extra 20% off your first order and get a FREE 60-day
            trial, to shop luxury beauty at our unbeatable members' prices.
            Code:{" "}
            <span className={promoBannerMediumText}>{promoCodeValue}</span>
          </p>
          <Button
            handleClick={onUsePromoCode}
            className={promoBannerCta}
            variant="primary"
          >
            {!isPromoCodeActivated && !isPromoCodeRejected ? (
              <span>
                <span>Activate Discount Code</span>
              </span>
            ) : (
              <div className={promoBannerCtaText}>
                <CheckIcon
                  className={promoBannerSvg}
                  stroke={color.background}
                  data-testid="CheckIcon"
                />
                <span>Discount Code Activated</span>
              </div>
            )}
          </Button>
        </div>
      </div>
    </div>
  )
}
